import { atom, selector } from 'recoil';
import { MvmoType } from 'src/types/type';

export const UserAgentState = atom<'MOBILEWEB' | 'PCWEB' | ''>({
  key: 'UserAgentState',
  default: '',
});

export const PCodeState = atom<string>({
  key: 'PCodeState',
  default: '046f13e8-8897', //제휴사 코드 없는 경우(제휴웹가입코드)
});

export const RequestIdState = atom<string>({
  key: 'RequestIdState',
  default: '',
});
export const MvmoTermsState = atom<MvmoType>({
  key: 'MvmoTermsState',
  default: {
    Terms: '',
    TermsTitle: '',
  }
})
export const MvnoCheckValue = atom<boolean>({
  key: 'MvnoCheckValue',
  default: false
})
export const VulnerableCheckState = atom<boolean>({
  key: 'VulnerableCheckState',
  default: false,
})
export const RecoilCommonList = selector({
  key: 'RecoilCommonList',
  get: ({ get }) => {
    return {
      userAgent: get(UserAgentState),
      pCode: get(PCodeState),
      requestId: get(RequestIdState),
      MvmoTerms: get(MvmoTermsState),
      MvnoCheck: get(MvnoCheckValue),
      VulnerableCheck: get(VulnerableCheckState),
    }
  }
})